import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Links } from '@/features/pagamentos/componentes/Links';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  situacao: z.enum(['aberto', 'pago', 'vencido', 'cancelado']).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

/** Links de pagamento (spec 013, CA-01 a CA-04). */
export const Route = createFileRoute('/_autenticado/pagamentos/links')({
  ...rotaDeTela('pagamentos.assinaturas'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Links
      busca={valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
